<template>
  <component
    :is="tag"
    class="zord-heading"
    :class="[`zord-heading--${level}`]"
  >
    {{ text }}
  </component>
</template>

<script>
export default {
  name: 'ZordHeading',
  props: {
    level: {
      type: Number,
      required: true,
      default: 1,
      validator(value) {
        return value >= 1 && value <= 4
      }
    },
    text: {
      type: String,
      required: true,
      default: ''
    }
  },
  computed: {
    tag() {
      return `h${this.level}`
    }
  }
}
</script>

<style lang="scss" scoped>
  .zord-heading {
    &--1 {
      font-size: var(--heading-size-1);
      font-weight: var(--font-weight-semibold);
      color: var(--headline-blue);
    }

    &--2 {
      font-size: var(--heading-size-2);
      font-weight: var(--font-weight-bold);
      color: var(--text-color);
    }

    &--3 {
      font-size: var(--heading-size-3);
      font-weight: var(--font-weight-semibold);
      color: var(--text-color);
    }

    &--4 {
      font-size: var(--heading-size-4);
      font-weight: var(--font-weight-bold);
      color: var(--primary-color);
      text-transform: uppercase;
    }
  }
</style>
